import { SambaTheme } from "../types/local"

const MCALLEN_THEME: SambaTheme = {
  locationInformation: {
    locationID: "IPCTX-AIRPT-MFEAP",
    locationName: "McAllen International Airport",
    zoneHeader: "McAllen International Airport",
    support: {
      phone: "9562138561",
      email: "parkmfe@interstateparking.com",
      hasOnsiteHelp: true,
      onsiteHelperTitle: "Parking ambassador",
    },
    timeZone: "America/Chicago",
  },
  light: {
    logoURL: "https://www.mcallenairport.com/images/logo.png",
    hues: {
      primary: {
        1: "#FCFDFE",
        2: "#F6F9FE",
        3: "#EBF3FD",
        4: "#DDEBFE",
        5: "#CCE1FC",
        6: "#B8D4F8",
        7: "#A1C3EE",
        8: "#7EABE3",
        9: "#08529D",
        10: "#00428B",
        11: "#2567B4",
        12: "#183457",
        contrast: "#FCFDFE",
      },
      secondary: {
        1: "#FEFDFB",
        2: "#FFFAE9",
        3: "#FFF3C0",
        4: "#FFEA9B",
        5: "#FFDF78",
        6: "#FAD374",
        7: "#E7C368",
        8: "#D5AB3B",
        9: "#FFCC0C",
        10: "#F8C323",
        11: "#997100",
        12: "#453A1E",
        contrast: "#1F1704",
      },
      neutral: {
        1: "#FBFCFD",
        2: "#F8F9FA",
        3: "#F1F3F5",
        4: "#ECEEF0",
        5: "#E6E8EB",
        6: "#DFE3E6",
        7: "#D7DBDF",
        8: "#C1C8CD",
        9: "#889096",
        10: "#7E868C",
        11: "#687076",
        12: "#11181C",
        contrast: "#FFFFFF",
      },
      success: {
        1: "#fbfefc",
        2: "#f2fcf5",
        3: "#e9f9ee",
        4: "#ddf3e4",
        5: "#ccebd7",
        6: "#b4dfc4",
        7: "#92ceac",
        8: "#5bb98c",
        9: "#30a46c",
        10: "#299764",
        11: "#18794e",
        12: "#153226",
        contrast: "#fbfefc",
      },
      caution: {
        1: "#fefdfb",
        2: "#fff9ed",
        3: "#fff4d5",
        4: "#ffecbc",
        5: "#ffe3a2",
        6: "#ffd386",
        7: "#f3ba63",
        8: "#ee9d2b",
        9: "#ffb224",
        10: "#ffa01c",
        11: "#ad5700",
        12: "#4e2009",
        contrast: "#4e2009",
      },
      danger: {
        1: "#fffcfc",
        2: "#fff8f8",
        3: "#ffefef",
        4: "#ffe5e5",
        5: "#fdd8d8",
        6: "#f9c6c6",
        7: "#f3aeaf",
        8: "#eb9091",
        9: "#e5484d",
        10: "#dc3d43",
        11: "#830011",
        12: "#381316",
        contrast: "#fffcfc",
      },
    },
  },
  dark: {
    logoURL: "https://www.mcallenairport.com/images/logo.png",
    hues: {
      primary: {
        1: "#0f1720",
        2: "#0f1b2d",
        3: "#10243e",
        4: "#102a4c",
        5: "#0f3058",
        6: "#0d3868",
        7: "#0a4481",
        8: "#0954a5",
        9: "#0091ff",
        10: "#369eff",
        11: "#52a9ff",
        12: "#eaf6ff",
        contrast: "#0f1720",
      },

      secondary: {
        1: "#1f1300",
        2: "#271700",
        3: "#341c00",
        4: "#3f2200",
        5: "#4a2900",
        6: "#573300",
        7: "#693f05",
        8: "#824e00",
        9: "#FFCC0C",
        10: "#F8C323",
        11: "#f1a10d",
        12: "#fef3dd",
        contrast: "#1F1704",
      },
      neutral: {
        1: "#161615",
        2: "#1c1c1a",
        3: "#232320",
        4: "#282826",
        5: "#2e2e2b",
        6: "#353431",
        7: "#3e3e3a",
        8: "#51504b",
        9: "#717069",
        10: "#7f7e77",
        11: "#a1a09a",
        12: "#ededec",
        contrast: "#FFFFFF",
      },
      success: {
        1: "#0d1912",
        2: "#0c1f17",
        3: "#0f291e",
        4: "#113123",
        5: "#133929",
        6: "#164430",
        7: "#1b543a",
        8: "#236e4a",
        9: "#30a46c",
        10: "#3cb179",
        11: "#4cc38a",
        12: "#e5fbeb",
        contrast: "#0d1912",
      },
      caution: {
        1: "#1f1300",
        2: "#271700",
        3: "#341c00",
        4: "#3f2200",
        5: "#4a2900",
        6: "#573300",
        7: "#693f05",
        8: "#824e00",
        9: "#ffb224",
        10: "#ffcb47",
        11: "#f1a10d",
        12: "#fef3dd",
        contrast: "#1f1300",
      },
      danger: {
        1: "#1f1315",
        2: "#291415",
        3: "#3c181a",
        4: "#481a1d",
        5: "#541b1f",
        6: "#671e22",
        7: "#822025",
        8: "#aa2429",
        9: "#e5484d",
        10: "#f2555a",
        11: "#ff6369",
        12: "#feecee",
        contrast: "#ffffff",
      },
    },
  },
}

export default MCALLEN_THEME
